import React from 'react';
import { AmountSection } from '../../components/amountSection';
import { AutoBetSection } from '../../components/autoBetSection';
import { FooterSection } from '../../components/footerSection';
import { DealSection } from '../../components/dealSection';

export function BottomContainer() {
  return (
    <div className='turbo-belote-web-game-bottom'>
      <div className='tb-g-b-btn-inner'>
        <div className='tb-g-b-btn-t'>
          <AmountSection />
          <AutoBetSection />
        </div>
        <DealSection />
        <FooterSection />
      </div>
    </div>
  );
}
